/**
 * 全局使用一个$auth.isLogin来控制用户是否登录，watch该变量来控制跳回登录页或首页 √
 * 场景：
 * 初次打开页面、刷新页面（获取token，userinfo，修改isLogin的值）
 * 接口拦截（http.js，401即过期，清除用户信息，修改isLogin）===
 * 登出（清除用户信息，修改isLogin）√
 * 登入（保存用户信息，修改isLogin）√
 */
// import iview from '_u/iview'
// import { Message, Spin } from 'iview';
import { Message, Loading } from 'element-ui';
import qs from 'qs';
import { Base64 } from 'js-base64';
import Cookies from 'js-cookie';
import api from '../api';
import router from '../router';
import ro from 'element-ui/src/locale/lang/ro';
import el from 'element-ui/src/locale/lang/el';
/** 'token' 转码 base64 */
const base64token = Base64.encode('token');

/** 配置项 */
const config = {
  client_id: 'gsl_front_end',
  grant_type: 'password',
};

let loading = Loading.service({
  fullscreen: true,
  background: 'rgba(0, 0, 0, 0.4)',
});

class Auth {
  /** 构造函数 */
  constructor() {
    this.userInfo = null; // 用户信息
    this.token = null; // token
    this.isLogin = true; // 用户是否已登录
    this.Vue = null; // Vue构造函数
  }

  /** 获取token，刷新token */
  getToken(username, pwd) {
    return new Promise((resolve, reject) => {
      api.login
          .getToken(
              qs.stringify({
                username: username,
                password: Base64.decode(pwd),
                client_id: config.client_id,
                // client_secret: '111fbe04-0192-402b-b0c6-36f5f2cc6119',
                grant_type: config.grant_type,
              }),
              null,
              {
                tipShow: false,
              },
          )
          .then((res) => {
            console.log('token获取成功', res);
            this.token = res.data.access_token; // token
            // this.getUserInfo();
            let expiredTime = new Date().getTime() + 60 * 60 * 1000;
            Message.success('登录成功！');

            // 登录成功之后，在localStorage上保存用户登录信息
            // localStorage.setItem(base64token, this.token);
            Cookies.set(base64token, this.token);
            sessionStorage.setItem('expiredTime', expiredTime);

            resolve(res);
          })
          .catch((err) => {
            if (err.status == 400) {
              Message.error('该用户已被禁用,请联系管理员');
            } else {
              Message.error('账号或密码错误');
            }
            reject(err);
          });
    });
  }

  /** 刷新token */
  refreshToken() {}

  /** 获取用户信息 */
  getUserInfo() {
    return new Promise((resolve, reject) => {
      api.login
          .getUserInfo()
          .then((res) => {
            this.userInfo = res.data;
            localStorage.setItem('userInfo', JSON.stringify(res.data));
            resolve(res.data);
          })
          .catch((err) => {
            reject(err);
          });
    });
  }

  /** 用户登录页登录 */
  login(username, pwd) {
    if (!username || !pwd) {
      Message.error('账号或密码不能为空！');
    } else {
      loading;
      this.getToken(username, pwd)
          .then(async (res) => {
            this.isLogin = true;
            this.handleRedirect();
            localStorage.setItem('username', username);
            this.Vue.prototype.$log.addItem('用户登录', '登录');
          })
          .catch((err) => {})
          .finally(() => {
            loading.close();
          });
    }
  }

  /**
   * 网上工商联单点登录 - 获取accessToken
   * @param {string} authCode 授权码
   * @param {string} appId 应用ID
   * @param {string} appSecret 应用密钥
   */
  ssoGetAccessToken(authCode) {
    var self = this;
    return new Promise(function(resolve, reject) {
      var params = {
        authCode: authCode
      };

      api.sso
        .getAccessToken(params, [], {
          tipShow: false
        })
        .then(function(res) {
          if (res.data && res.data.code === 200) {
            resolve(res.data.data);
          } else {
            reject(new Error(res.data.msg || res.data.message || '获取accessToken失败'));
          }
        })
        .catch(function(err) {
          reject(err);
        });
    });
  }

  /**
   * 网上工商联单点登录 - 换取系统token
   * @param {string} accessToken SSO返回的accessToken
   */
  ssoExchangeToken(accessToken) {
    var self = this;
    return new Promise(function(resolve, reject) {
      var params = {
        accessToken: accessToken
      };

      api.sso
        .exchangeToken(params, [], {
          tipShow: false
        })
        .then(function(res) {
          // 接口直接返回token数据格式
          var tokenData = res.data;

          if (tokenData && tokenData.access_token) {
            resolve(tokenData);
          } else {
            reject(new Error(tokenData.msg || tokenData.message || '换取系统token失败'));
          }
        })
        .catch(function(err) {
          reject(err);
        });
    });
  }

  /**
   * 网上工商联单点登录 - 完整登录流程
   * 1. 通过authCode获取SSO accessToken
   * 2. 通过SSO accessToken换取系统token
   * 3. 复用getToken成功后的流程（保存token、设置登录状态等）
   * @param {string} authCode 授权码
   * @param {string} appId 应用ID
   * @param {string} appSecret 应用密钥
   */
  ssoLogin(authCode) {
    var self = this;
    return new Promise(function(resolve, reject) {
      // 步骤1: 获取SSO accessToken (只需要authCode)
      self.ssoGetAccessToken(authCode)
        .then(function(tokenData) {
          var ssoAccessToken = tokenData.accessToken;
          // 步骤2: 换取系统token
          return self.ssoExchangeToken(ssoAccessToken);
        })
        .then(function(systemTokenData) {
          // 步骤3: 复用getToken成功后的流程
          var systemToken = systemTokenData.access_token || systemTokenData.accessToken;
          var expiresIn = systemTokenData.expiresIn || systemTokenData.expires_in || 3600;
          var userName = systemTokenData.userName || systemTokenData.preferred_username || '';

          self.token = systemToken;
          var expiredTime = new Date().getTime() + expiresIn * 1000;
          Message.success('单点登录成功！');

          // 保存登录信息
          Cookies.set(base64token, systemToken);
          sessionStorage.setItem('expiredTime', expiredTime);
          if (userName) {
            localStorage.setItem('username', userName);
          }

          // 设置登录状态
          self.isLogin = true;

          // 直接跳转到首页
          setTimeout(function() {
            router.push('/gather');
          }, 500);

          resolve({ accessToken: systemToken, userName: userName });
        })
        .catch(function(err) {
          // 登录失败时，不设置isLogin状态，避免触发watch导致跳转到login页面
          // 让SsoLogin.vue页面自己处理错误显示
          reject(err);
        });
    });
  }

  /** 用户登出，清除用户信息，并跳转登录页 */
  logout() {
    this.isLogin = false; // 用户是否已登录
    this.userInfo = null; // 用户信息
    this.token = null; // token
    Cookies.remove(base64token);
    sessionStorage.clear();
    localStorage.clear();
    const tmp = window.location.hash;
    let redirect;
    if (tmp.indexOf('redirect=') >= 0) {
      redirect = tmp.split('redirect=')[1];
    } else {
      redirect = tmp.split('#/')[1];
    }
    if (redirect && redirect !== 'login') router.push(`/login?redirect=${redirect}`);
    else router.push('/login');
    console.log('退出登录');
  }

  /** 重定向 */
  handleRedirect() {
    /** 延迟跳转，否则登录页刷新会跳转到首页 */
    setTimeout(() => {
      const tmp = window.location.hash;
      let redirect;
      if (tmp.indexOf('redirect=') >= 0) {
        redirect = tmp.split('redirect=')[1];
      } else {
        redirect = tmp.split('#/')[1];
      }

      // SSO 登录页面不触发重定向，让页面自己处理登录逻辑
      if (redirect && redirect.indexOf('sso-login') >= 0) {
        return;
      }

      if (this.isLogin) {
        if (redirect && redirect !== 'login') router.push('/' + redirect);
        else router.push('/gather');
      } else {
        if (redirect && redirect !== 'login') router.push(`/login?redirect=${redirect}`);
        else router.push('/login');
      }
    }, 200);
  }

  /** 初始化监听事件 */
  initEvent() {
    if (!this.Vue) return;

    const vm = new this.Vue();

    // 获取当前路径
    const getCurrentPath = () => {
      const hash = window.location.hash;
      return hash.split('?')[0].replace('#/', '');
    };

    // 包装 handleRedirect，SSO 页面不跳转
    const safeHandleRedirect = () => {
      const currentPath = getCurrentPath();
      // SSO 登录页面不触发重定向（除非 isLogin === true）
      if (currentPath === 'sso-login' && !this.isLogin) {
        return;
      }
      this.handleRedirect();
    };

    /** immediate: true */
    safeHandleRedirect();

    /** watch auth.isLogin */
    vm.$watch('$auth.isLogin', () => {
      safeHandleRedirect();
    });

    /** watch hash or route.path */
    window.addEventListener('hashchange', () => {
      safeHandleRedirect();
    });
  }

  /** 是否有权限 */
  hasPermission(code, needOnlyOne) {
    /** 未设置权限码 */
    if (!code) {
      return true;
    }

    let permissionList = this.userInfo && this.userInfo.resource;
    // console.log(permissionList, '-p')
    if (!permissionList) {
      return false;
    }

    let hasPermission = false;

    // code 为数组时
    if (Array.isArray(code)) {
      if (needOnlyOne) {
        for (let item of code) {
          if (this.hasPermission(item)) {
            hasPermission = true;
            break;
          }
        }
      } else {
        hasPermission = true;
        for (let item of code) {
          if (!this.hasPermission(item)) {
            hasPermission = false;
            break;
          }
        }
      }
    }

    /** 有权限码 */
    hasPermission = permissionList.includes(code);

    return hasPermission;
  }
}

/** 注册Auth */
Auth.install = function (Vue) {
  let auth = Vue.observable(new Auth());

  auth.Vue = Vue;

  /** 将$auth变成响应式 */
  Vue.prototype.$auth = auth;

  /** 初始化监听事件 */
  auth.initEvent();

  /** 先用localStorage中拿token */
  let token = Cookies.get(base64token),
      expiredTime = sessionStorage.getItem('expiredTime');

  // 从URL hash判断是否是SSO登录页面（比router.currentRoute更可靠）
  const hash = window.location.hash;
  if (hash.indexOf('#/sso-login') >= 0) {
    return;
  }

  let { meta } = { ...router.currentRoute };
  if (meta.noCheck) return;

  // 登录过期
  if (new Date().getTime() >= expiredTime) {
    sessionStorage.clear();
    Cookies.remove(base64token);
    token = null;
  }

  if (token) {
    auth.token = token;
    Cookies.set(base64token, token, { domain: '.datanas.cn' });
  } else {
    auth.logout();
  }
};

export default Auth;
